import BpmInput from "../ui/BpmInput";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import useEditorForm from "../hooks/useEditorForm";
import SelectInput from "../ui/SelectInput";
import TextInput from "../ui/TextInput";
import React from "react";
import TagDropdown from "./TagDropdown";
import { normalizeBreaks, normalizeTags } from "../utils";
function TrackRow({
  track,
  onChange,
  canEditDuration,
  canEditTrackInfo,
  highlight,
  tagOptions = null,
  onCreateTag,
  breakOptions = [],
  disabled = false,
}) {
  const [fields, setFields] = useEditorForm({
    position: track.position || "",
    title: track.title || "",
    duration: track.duration || "",
    bpm: track.bpm ?? "",
    rating: track.love
      ? "love"
      : track.like
        ? "like"
        : track.hate
          ? "hate"
          : "",
    breaks: normalizeBreaks(track.breaks),
    notes: track.notes || "",
    tags: tagOptions ? normalizeTags(track.tags) : track.tags || "",
  });
  const handleChange = (field, value) => {
    const updated = {
      ...fields,
      [field]: value,
    };
    setFields(updated);
    const data = {
      ...(canEditDuration
        ? {
            duration: updated.duration,
          }
        : {}),
      ...(canEditTrackInfo
        ? {
            title: updated.title,
            position: updated.position,
          }
        : {}),
      bpm: updated.bpm,
      like: updated.rating === "like",
      love: updated.rating === "love",
      hate: updated.rating === "hate",
      notes: updated.notes,
      tags: tagOptions ? updated.tags.join(", ") : updated.tags,
    };
    if (Array.isArray(updated.breaks)) {
      data.breaks = updated.breaks;
    }
    onChange(track.id, data);
  };
  return (
    <TableRow className={`track${highlight ? " highlight" : ""}`}>
      <TableCell>
        {canEditTrackInfo ? (
          <TextInput
            disabled={disabled}
            type="text"
            value={fields.position}
            aria-label="Position"
            onChange={(e) => handleChange("position", e.target.value)}
          />
        ) : (
          track.position
        )}
      </TableCell>
      <TableCell>
        {canEditTrackInfo ? (
          <TextInput
            disabled={disabled}
            className="title-input"
            value={fields.title}
            aria-label="Track title"
            onChange={(e) => handleChange("title", e.target.value)}
            multiline
            maxRows={4}
          />
        ) : (
          track.title
        )}
      </TableCell>
      <TableCell>
        {canEditDuration ? (
          <TextInput
            disabled={disabled}
            type="text"
            value={fields.duration}
            aria-label="Duration"
            onChange={(e) => handleChange("duration", e.target.value)}
          />
        ) : (
          track.duration
        )}
      </TableCell>
      <TableCell>
        <BpmInput
          disabled={disabled}
          value={fields.bpm}
          aria-label="BPM"
          onChange={(e) => handleChange("bpm", e.target.value)}
        />
      </TableCell>
      <TableCell>
        <SelectInput
          disabled={disabled}
          value={fields.rating}
          aria-label="Rating"
          onChange={(e) => handleChange("rating", e.target.value)}
        >
          <option value=""></option>
          <option value="like">👍</option>
          <option value="love">❤️</option>
          <option value="hate">❌</option>
        </SelectInput>
      </TableCell>
      <TableCell>
        <TextInput
          disabled={disabled}
          className="notes-input"
          value={fields.notes}
          aria-label="Notes"
          onChange={(e) => handleChange("notes", e.target.value)}
          multiline
          maxRows={4}
        />
      </TableCell>
      <TableCell>
        {tagOptions ? (
          <TagDropdown
            disabled={disabled}
            options={tagOptions}
            selected={fields.tags}
            onChange={(opts) => handleChange("tags", opts)}
            onCreate={onCreateTag}
          />
        ) : (
          <TextInput
            disabled={disabled}
            type="text"
            value={fields.tags}
            aria-label="Tags"
            onChange={(e) => handleChange("tags", e.target.value)}
          />
        )}
      </TableCell>
    </TableRow>
  );
}
export default TrackRow;
